import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  selectEnabledStandards,
  selectOrganizationStandardsStatus,
  selectPermissionStandardsMap,
} from './organizationStandardsSlice';
import {
  selectEffectivePlatformPermissions,
  selectPlatformPermissionsStatus,
} from '../platformPermissions/platformPermissionsSlice';
import { hasPlatformVisibility } from '../platformPermissions/platformAccessLevel';
import { isModuleVisibleForStandards } from '../../constants/isoStandards';

/**
 * Visibilidad final = norma habilitada Y permiso del usuario.
 */
export function useModuleAccess() {
  const effective = useSelector(selectEffectivePlatformPermissions);
  const permStatus = useSelector(selectPlatformPermissionsStatus);
  const enabledStandards = useSelector(selectEnabledStandards);
  const permissionStandards = useSelector(selectPermissionStandardsMap);
  const standardsStatus = useSelector(selectOrganizationStandardsStatus);

  const ready =
    permStatus === 'succeeded' &&
    effective !== null &&
    standardsStatus === 'succeeded' &&
    enabledStandards !== null &&
    permissionStandards !== null;

  const canAccess = useCallback(
    (permissionKey: string): boolean => {
      if (!ready || !effective || !enabledStandards || !permissionStandards) {
        return false;
      }
      if (!hasPlatformVisibility(effective[permissionKey])) {
        return false;
      }
      return isModuleVisibleForStandards(
        permissionKey,
        enabledStandards,
        permissionStandards,
      );
    },
    [ready, effective, enabledStandards, permissionStandards],
  );

  return { canAccess, ready };
}
